/**
 * Higher-order function per memorizzare un'istanza della classe Zone in oggetti
 * che non lo prevedono
 * @param {Zone}    zone
 * @returns {Function}
 */
export default (zone) => (obj) => {
    obj.zone = zone;
    return obj;
};